import Head from "framework/ui/content/Head";
import NavBar from "framework/ui/content/NavBar";
import PageContent from "framework/ui/content/PageContent";
import PageTitle from "framework/ui/content/PageTitle";
import PageSections from "framework/ui/content/PageSections";
import GuestBook from "framework/ui/guestbook/GuestBook";
import Copyright from "framework/ui/content/Copyright";
import Page from "framework/ui/content/Page";
import React from "react";
import Gallery from "framework/ui/gallery/Gallery";
import './css/Gallery.css'
import './css/GuestBook.css'
import './css/NavBar.css'
import './css/PageSections.css'

/**
 * @typedef MyPageProps
 *
 * @property {number} [pageId]  Specific page ID to display.
 */

/**
 * Component for site-specific page contents.
 *
 * @param props {MyPageProps}
 * @returns {JSX.Element}
 * @constructor
 */
export default function MyPage(props) {
  return (
    <Page {...props}>
      <Head/>
      <PageTitle showTitle={true}/>
      <NavBar brand={''} expand={''}/>
      <PageContent>
        <PageSections/>
        <GuestBook guestBookId={231} pageId={8690}/>
        <Gallery galleryId={1093} pageId={8691}/>
        <Copyright startYear='2022'/>
      </PageContent>
    </Page>
  );
}